import React from 'react';
import ReactToolTip from 'react-tooltip';
import {getFormattedDuration} from "../../../../../utils/date";

const TOOLTIP_RUNTIME_ID = "runtimeTip";

/**
 * A component that displays duration
 * information on the recording form
 */
const Runtime = ({runtime}) => (
    <div style={{background: 'rgba(0,0,0,0.3)', color: 'white', position: 'absolute', top: 10, right: 10, padding: '0 5px'}}>
        <div data-tip data-for={TOOLTIP_RUNTIME_ID}>
            {getFormattedDuration(runtime)}
        </div>
        <ReactToolTip id={TOOLTIP_RUNTIME_ID}>
            <span>The duration of the uploaded recording.</span>
        </ReactToolTip>
    </div>
);


export default Runtime;



// WEBPACK FOOTER //
// ./src/components/unit/recordings/recordingcard/information/Runtime.jsx